/* global ga, _sf_async_config, pSUPERFLY, _cc10461, Sailthru, COMSCORE */
import URL from "url-parse";
import { GA_KEY, GA_TRACKED_LINK_TYPE } from "../config/constants";

function initialize () {
  initGA();
  initComscore();
}

function initGA() {
  if (typeof ga !== "undefined") {
    ga("create", GA_KEY, "auto");
    ga("require", "displayfeatures");

    // This won't get hit running webpack-dev-server
    if (document.title.indexOf(" - Axios") > 0) {
      const slicedTitle = document.title.slice(0, document.title.indexOf(" - Axios"));
      ga("send", "pageview", { title: slicedTitle });
    } else {
      ga("send", "pageview");
    }
  }
}

function initComscore() {
  let _comscore = _comscore || [];

  _comscore.push(
    { c1: "2", c2: "24196029" }
  );

  let s = document.createElement("script");
  let el = document.getElementsByTagName("script")[0];
  s.async = true;
  s.src = (document.location.protocol === "https:" ? "https://sb" : "http://b") + ".scorecardresearch.com/beacon.js";
  el.parentNode.insertBefore(s, el);
}

function setUser(id) {
  typeof _cc10461 !== "undefined" && id && ga("set", "dimension1", id);
}

function setStream (stream) {
  typeof _cc10461 !== "undefined" && stream && ga("set", "dimension8", stream);
}

function setSections(sections) {
  _sf_async_config.sections = sections.map((s) => s.slug).join(",");
}

function setAuthors(authors) {
  _sf_async_config.authors = authors.map((author) => author.username).join(",");
}

function pageView() {
  typeof ga !== "undefined" && ga("send", "pageview");
}

/*
  This event should be triggered if a post is still in view 3 seconds
  after it was initially registered in the viewport
 */
function userScrollsStoryIntoView(data) {
  const { story, stream } = data;

  let unpinned = story.is_featured && !story.new_featured;
  const url = new URL(story.permalink);
  typeof ga !== "undefined" && ga("send", {
    hitType: "pageview",
    title: story.headline,
    page: url.pathname,
    dimension4: story.is_featured && !unpinned ? "Yes" : "",
    dimension5: unpinned ? "Yes" : "",
    dimension8: stream,
    dimension9: story.authors.map((author) => author.display_name).join("|"),
    dimension11: story.id,
  });

  // Chartbeat
  setSections(story.sections.concat(story.primary_section || []));
  setAuthors(story.authors);
  typeof pSUPERFLY !== "undefined" && pSUPERFLY.virtualPage(story.permalink, story.headline);

  // Lotame
  const sectionTags = story.sections.concat(story.primary_section || []).map((s) => s.slug)
    .concat(story.tags.concat(story.primary_tag || []).map((t) => t.name));
  let postAttributes = sectionTags.join().replace(/ /g,"_");
  typeof _cc10461 !== "undefined" && _cc10461.bcpw("int",postAttributes,"act",postAttributes);

  // Sailthru
  typeof Sailthru !== "undefined" && Sailthru.track("pageview", {
    url: story.permalink,
  });

  // Comscore
  (typeof COMSCORE !== "undefined" && COMSCORE.beacon(
    { c1: "2", c2: " 24196029" }
  ));
}

function userClicksOnTrackedLink(streamSlug, actionName, buttonLabel) {
  const stream = streamSlug || "";
  typeof ga !== "undefined" && ga("send", {
    hitType: "event",
    eventCategory: `clicks_${stream}`,
    eventAction: `clicks_${stream}_${actionName}`,
    eventLabel: `Clicks on ${buttonLabel} in ${stream}`,
  });
}

const userClicksInternalLink = (stream, label) =>
  userClicksOnTrackedLink(stream, GA_TRACKED_LINK_TYPE.LINK, label);

const userClicksSaveTag = (stream) =>
  userClicksOnTrackedLink(stream, GA_TRACKED_LINK_TYPE.SAVE, "Save button");

const userClicksReadAnother = (stream) =>
  userClicksOnTrackedLink(stream, GA_TRACKED_LINK_TYPE.READ_ANOTHER, "Read another button");

const userClicksKeepReading = (stream) =>
  userClicksOnTrackedLink(stream, GA_TRACKED_LINK_TYPE.READ_MORE, "Keep reading button");

const userClicksCopyLink = (stream) =>
  userClicksOnTrackedLink(stream, GA_TRACKED_LINK_TYPE.SS_CL, "Copy link button");

const userClicksFacebook = (stream) =>
  userClicksOnTrackedLink(stream, GA_TRACKED_LINK_TYPE.SS_FB, "Facebook share button");

const userClicksTwitter = (stream) =>
  userClicksOnTrackedLink(stream, GA_TRACKED_LINK_TYPE.SS_TW, "Twitter share button");

const userClicksLinkedIn = (stream) =>
  userClicksOnTrackedLink(stream, GA_TRACKED_LINK_TYPE.SS_LI, "LinkedIn share button");

const isStoryInView = (card) => {
  // In view story is one where top is above top of page and bottom is still in view
  const bounds = card.getBoundingClientRect();
  return bounds.top < 60 && bounds.bottom > 60;
};

export default {
  initialize,
  initGA,
  initComscore,
  setUser,
  setStream,
  setSections,
  setAuthors,
  pageView,
  userScrollsStoryIntoView,
  userClicksOnTrackedLink,
  userClicksInternalLink,
  userClicksSaveTag,
  userClicksReadAnother,
  userClicksKeepReading,
  userClicksCopyLink,
  userClicksFacebook,
  userClicksTwitter,
  userClicksLinkedIn,
  isStoryInView,
};



// WEBPACK FOOTER //
// ./src/utils/analytics.js